import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import { Button, ButtonGroup, Grid } from "@mui/material";
import {
  Add as AddIcon,
  Archive as ArchiveIcon,
  FilterList as FilterListIcon,
  RemoveRedEye as RemoveRedEyeIcon,
} from "@mui/icons-material";
import AddNewCatalog from "../../Catalog/modal_add";
import CatalogListComponent from "../../Catalog/list/catalog-list";
import useAuth from "../../../hooks/useAuth";
import UpdateCatalogComponent from "../../Catalog/modal_edit";

export default function NFSCatalogListComponent({
  nfConfiguration,
  loadConfig,
  setIsDirtyData,
}) {
  let { getApi, postApi, deleteApi } = useAuth();

  let [catalogList, setCatalogList] = React.useState([]);

  let [selectedValue, setSelectedValue] = React.useState([]);
  let [loadingCatalogList, setLoadingCatalogList] = React.useState(true);


  const loadCatalog =  async (page, limit = 5) =>{
     setLoadingCatalogList(true);
      const response = await getApi("/catalog/list", {
        page: page,
        limit: limit,
      });
      setLoadingCatalogList(false);
      if (!response) {
        return;
      }
      setCatalogList(response);
  }

  const deleteById = React.useCallback(
    async (id) => {
      if(!window.confirm("Você realmente quer deletar esse catálogo?\nCobranças emitidas com esse catálogo continuará em vigor.")){
        return;
      }
      const response = await deleteApi("/catalog/delete/" + id);
      loadCatalog();
    },
    [deleteApi]
  );

  React.useEffect(() => {
    loadCatalog();

  }, []);
  const [btnAddCatalog, setBtnAddCatalog] = React.useState(false);
  const [btnUpdateCatalog, setBtnUpdateCatalog] = React.useState(false);

  return (
    <React.Fragment>
      <Grid>
        <Button
          variant="contained"
          color="primary"
          sx={{ marginLeft: 5 }}
          size="small"
          onClick={(e) => setBtnAddCatalog(true)}
        >
          <AddIcon />
          Adicionar novo
        </Button>

        {catalogList && (
          <CatalogListComponent
            catalogList={catalogList}
            layout="nfse"
            setSelectedValue={setSelectedValue}
            setBtnUpdateCatalog={setBtnUpdateCatalog}
            loadingCatalogList={loadingCatalogList}
            loadCatalog={loadCatalog}
            deleteById={deleteById}
            key={nfConfiguration}
          />
        )}
      </Grid>

      <AddNewCatalog
        key={btnAddCatalog}
        open={btnAddCatalog}
        onClose={(e) => setBtnAddCatalog(false)}
        allowCatalogType={[2]}
      />
      {btnUpdateCatalog && selectedValue && (
        <UpdateCatalogComponent
          key={btnUpdateCatalog}
          open={btnUpdateCatalog}
          catalogData={selectedValue}
          onClose={(e) => setBtnUpdateCatalog(false)}
          allowCatalogType={[2]}
        />
      )}
    </React.Fragment>
  );
}
